diy.angular.registerDirective('diyfmprogress', ['$timeout' , function($timeout) {
    return {
        restrict: 'A',
        link: function(scope, elem, attr) {
            var config = scope.$eval(attr.diyfmprogress);
            
            /*
             * Optimization: As we can potentially have thousdans of images here, we should not
             * crowd the DOM with elements that are not needed for all, such as the progress element.
             * 
             * For this, we watch the upload progress and if it's the case, we dynamically create a
             * progress element, and take care of it's updation and removal outside the angularjs 
             * flow and digest cycle. In this way angular reduces the number of watches over the progress
             * value to one, which updates the DOM independently
             */
            
            /* keep some references for the progress and the thumb element */
            var 
                $progress, 
                uploadProgress = typeof config.getter === 'function' ? config.getter() : undefined
            ;
            
            if(uploadProgress !== undefined && uploadProgress < 1) {
                // we can watch any function
                var removeProgressWatch = scope.$watch(config.getter, function(newProgress, oldProgress) {
                    /* if we've got a progress event (eg. 0%, 5%, 10%, etc) */
                    if (typeof newProgress !== 'undefined') {
                        
                        /* we create the progress element, if not here already */
                        if (!$progress) {
                            $progress = jQuery('<div class="fm-progress"></div>');
                            $progress.appendTo(jQuery(elem));
                        }
                        
                        // set the progress width
                        // but it should be not less that 100%
                        // and we will force it to be greater that 10%
                        // because some browsers only do some notifications at the end
                        // so user don't have a smooth experience
                        $progress.width(Math.max(10, Math.min(100, Math.ceil(newProgress * 100))) + '%');
                        
                        /* if progress reached 100% */
                        if (newProgress >= 1) {
                            $timeout(function() {
                                /* when progress reaches 100%, just swipe the progress to right */
                                $progress.css({
                                    right: 0,
                                    left: 'auto',
                                    width: 0
                                });
                                /* afterwards, remove the progress element to keep the DOM clean, as we found it */
                                $timeout(function() {
                                    $progress.remove();
                                    $progress = null;
                                    config.runOnce && removeProgressWatch();
                                    config.onFinish && config.onFinish();
                                }, 200);
                            }, 200);                        
                        }
                    }
                });
            }
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                elem = null;
            });            
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmprogress.js
 ** module id = 976
 ** module chunks = 0
 **/